import { initializeDB } from '../config/db';
import { BUS_INSPECTION_STORE } from '../config/constants';

export const busInspectionService = {
    async saveToIndexedDB(formData) {
        try {
            const db = await initializeDB();
            const tx = db.transaction(BUS_INSPECTION_STORE, 'readwrite');
            const store = tx.objectStore(BUS_INSPECTION_STORE);
            
            const dataToSave = {
                ...formData,
                id: formData.id || Date.now(),
                lastModified: new Date().toISOString()
            };
            
            await store.put(dataToSave);
            await tx.done;
            
            console.log('Bus Inspection saved to IndexedDB:', dataToSave.id);
            return dataToSave;
        } catch (error) {
            console.error('Error saving to IndexedDB:', error);
            throw error;
        }
    },

    async getFromIndexedDB(id) {
        try {
            const db = await initializeDB();
            const tx = db.transaction(BUS_INSPECTION_STORE, 'readonly');
            const store = tx.objectStore(BUS_INSPECTION_STORE);
            const data = await store.get(id);
            await tx.done;
            return data;
        } catch (error) {
            console.error('Error getting from IndexedDB:', error);
            throw error;
        }
    },

    async getAllFromIndexedDB() {
        try {
            const db = await initializeDB();
            const tx = db.transaction(BUS_INSPECTION_STORE, 'readonly');
            const store = tx.objectStore(BUS_INSPECTION_STORE);
            const data = await store.getAll();
            await tx.done;
            return data || [];
        } catch (error) {
            console.error('Error getting all from IndexedDB:', error);
            return [];
        }
    },

    async deleteFromIndexedDB(id) {
        try {
            const db = await initializeDB();
            const tx = db.transaction(BUS_INSPECTION_STORE, 'readwrite');
            const store = tx.objectStore(BUS_INSPECTION_STORE);
            await store.delete(id);
            await tx.done;
            console.log('Bus Inspection deleted from IndexedDB:', id);
        } catch (error) {
            console.error('Error deleting from IndexedDB:', error);
            throw error;
        }
    }
};

